import { React, useEffect, useState } from 'react'
import Menu from './sub_components/Menu.js'
import ArticleList from './sub_components/ArticleList.js'
import FilterList from './sub_components/FilterList.js'
import LoadingSpinner from './sub_components/LoadingSpinner.js'
import '../stylesheets/ArticlesSS.css'

import captcha from "../images/icons/captcha.png"

import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAnalytics } from "firebase/analytics";


import { Helmet } from 'react-helmet'

function Articles() {

  // page title - SEO
  document.title = "Ak - Software Articles";
  //makes a request via the API to get the list of articles, using this list of objects, map them into repeatable components
  //dummy array of data
  const firebaseConfig = {
    apiKey: "AIzaSyAHgS8Q5mUbdXnLSBlKDeRgsDjlXVl3Snk",
    authDomain: "blog-adam-kaminski.firebaseapp.com",
    projectId: "blog-adam-kaminski",
    storageBucket: "blog-adam-kaminski.appspot.com",
    messagingSenderId: "479060367833",
    appId: "1:479060367833:web:c92d07653a77b78181a1c8",
    measurementId: "G-GNRTCPM9C6",
    databaseURL: "https://blog-adam-kaminski-default-rtdb.europe-west1.firebasedatabase.app"
  };
  const app = initializeApp(firebaseConfig);
  //eslint-disable-next-line
  const analytics = getAnalytics(app);

  // eslint-disable-next-line
  const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LcHvl8hAAAAAKCvepBnWlKE_5fqB2jtUOtczm-O")
  });

  //accessing
  const [articles, setArticles] = useState([])

  useEffect(() => {

    //fetching data based on firebase link
    const db = getDatabase(app);
    const articleFetch = ref(db, 'articles/');//Fetching all articles
    onValue(articleFetch, (snapshot) => {
      const data = Object.entries(snapshot.val());
      let arrReverse = data;
      arrReverse.reverse();
      setArticles(arrReverse);
    });

    // eslint-disable-next-line
  }, [])

  const [filter, setFilter] = useState({
    Topic: undefined,
    Date: undefined
  });

  /**
     * 
     * @param {String} topic - Only provided when user selects a specific topic using the #topic functions 
     */
  function update(topic = undefined) {
    //get the inputs, setFilter
    const filters = document.getElementsByClassName('filter');
    setFilter({
      //default topic means that no topic was provided and clicked on, meaning that it resorts to regular search/filter
      Topic: (topic !== undefined) ? topic : (filters[0].value.length === 0 ? undefined : filters[0].value),
      Date: filters[1].value === '' ? undefined : filters[1].value
    })
  }
  function reset() {
    const filters = document.getElementsByClassName('filter');
    for (var input of filters) {
      input.value = ''
    }
    setFilter({
      Topic: undefined,
      Date: undefined
    })
  }

  // Route user on click of record to the /article/:id where the id is the key, which is what's used to find in the db
  return (
    <div id='articles_container'>
      <Helmet>
        <meta name="description" content="ASoftware articles about Databases, Programming, Software Development, SQL, JS, C#, Java and more" data-react-helmet="true" />
        <meta name="keywords" content="Article Read Discover Analyse Study Engage Software Solution" data-react-helmet="true" />
        <meta name="author" content="Adam Kaminski" data-react-helmet="true" />
        <meta name="title" content="Software development articles" data-react-helmet="true" />
      </Helmet>
      <Menu></Menu>
      <section id='center'>
        <FilterList setFilter={setFilter} update={update} reset={reset}></FilterList>
        {(articles.length === 0) ? <LoadingSpinner></LoadingSpinner> : <ArticleList data={articles} filter={filter} update={update}></ArticleList>}
      </section>
      <img src={captcha} alt="captcha" id="captcha"></img>
    </div>
  )
}

export default Articles